import { ReactNode, useState, createContext, useContext, useMemo } from 'react'

export type PayloadState = 'idle' | 'processing' | 'completed'

type PayloadProcessingStateContextType = {
  payloadState: PayloadState
  setPayloadState: (value: PayloadState) => void
}

const PayloadProcessingStateContext = createContext<PayloadProcessingStateContextType | undefined>(undefined)

export function usePayloadProcessingState() {
  const context = useContext(PayloadProcessingStateContext)
  if (!context) {
    throw new Error('usePayloadProcessingState must be used within a PayloadProcessingStateProvider')
  }
  return context
}

export function PayloadProcessingStateProvider({ children }: { children: ReactNode }) {
  const [payloadState, setPayloadState] = useState<PayloadState>('idle')
  const value = useMemo(() => ({
    payloadState,
    setPayloadState
  }), [payloadState]);
  return (
    <PayloadProcessingStateContext.Provider value={value}>
      {children}
    </PayloadProcessingStateContext.Provider>
  )
}
